import Products from './pages/Products/Products';
import DevelopmentSafety from "./components/DevelopmentSafety/DevelopmentSafety";
import SupplyDispatch from './pages/SupplyDispatch/SupplyDispatch';
import Purchasing from './pages/Purchasing/Purchasing';
import PurchasingDraft from './pages/PurchasingDraft/PurchasingDraft';
import { purchasingApi } from './pages/Purchasing/api';
import useSupplyDispatchAccess from './hooks/useSupplyDispatchAccess';
import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import AppTopbar from './AppTopbar';
import AppFooter from './AppFooter';
import AppConfig from './AppConfig';
import AppRightMenu from './AppRightMenu';
import { canUserAccessModule, canAccessMachineInspections, canUserAccessMachinePlatforms, canAccessCoffeeRegistration, canAccessCoffeeStatistics } from './navigation/moduleAccess';
import CoffeeStatistics from './pages/CoffeeStatistics/CoffeeStatistics';
import useModuleAccessRefresh from './hooks/useModuleAccessRefresh';
// import AppBreadcrumb from './AppBreadcrumb';
import { ToastContainer } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import Dashboard from './components/Dashboard';
import Login from './pages/Login';
import ForgetPassword from './pages/ForgetPassword';
import ForcePasswordChange from './pages/ForcePasswordChange';
import PrimeReact, { addLocale, locale as setPrimeLocale } from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import { useSelector } from 'react-redux';
import Users from './pages/Users/Users';
import Machines from './pages/Machines/Machines';
import RouteManagement from './pages/Routes/RouteManagement';
import OpenComplaints from './pages/Complains/OpenComplaints';
import CallHistory from './pages/CallHistory/CallHistory';
import { canReadCallHistory } from './pages/CallHistory/callHistoryUtils';
import CloseComplaints from './pages/Complains/CloseComplaints';
import RefundQueue from './pages/Complains/RefundQueue';
import ChatBox from './components/ChatBox';
import Profile from './pages/Profile';
import Questions from './pages/Questions/Questions';
import Teams from './pages/Teams/Teams';
import PartsInventory from './pages/PartsInventory/PartsInventory';
import Reports from './pages/Reports/Reports';
import CustomerMachineReport from './pages/Reports/CustomerMachineReport';
import RepairOrders from './pages/RepairOrders/RepairOrders';
import MachineInspections from './pages/MachineInspections/MachineInspections';
import RepairOrderDetail from './pages/RepairOrders/RepairOrderDetail';
import MachineMovements from './pages/MachineMovements/MachineMovements';
import PreventiveMaintenance from './pages/PreventiveMaintenance/PreventiveMaintenance';
import HRModule from './pages/HR/HRModule';
import ParlevelDashboard from './pages/Parlevel/ParlevelDashboard';
import ParlevelData from './pages/Parlevel/ParlevelData';
import ParlevelRoutePlanning from './pages/Parlevel/ParlevelRoutePlanning';
import ParlevelCoinTubes from './pages/Parlevel/ParlevelCoinTubes';
import OperatorDashboard from './pages/OperatorDashboard/OperatorDashboard';
import QuickBooksModule from './pages/QuickBooks/QuickBooksModule';
import OKRModule from './pages/OKR/OKRModule';
import VentasModule from './pages/Ventas/VentasModule';
import JetinnoDashboard from './pages/Jetinno/JetinnoDashboard';
import TcnDashboard from './pages/Tcn/TcnDashboard';
import JetinnoConsumptionReport from './pages/Jetinno/JetinnoConsumptionReport';
import RevenueReconciliation from './pages/RevenueReconciliation/RevenueReconciliation';
import { Access } from './pages/Access';
import { getPreferredLanguage } from './utilities/languagePreference';
import { translateUiText } from './utilities/siteTranslations';
import SyncroSidebar from './SyncroSidebar';
import WorkspaceTabs from './WorkspaceTabs';
import { buildSyncroNavigation } from './navigation/syncroNavigation';
import { hasQuickBooksFinanceDashboardAccess, hasQuickBooksManagementDashboardAccess } from './utilities/quickbooksAccess';

const COMMERCIAL_ROLE_UIDS = new Set(['sales', 'seller']);
const DEMO_REQUESTER_EMAILS = new Set([
    'lisbeth.velasquez@coffeevending.com.pa',
    'valentina@coffeevending.com.pa'
]);
const OPERATOR_DASHBOARD_FULL_ACCESS_EMAILS = new Set(['mauricio.cruz@coffeevending.com.pa']);
const SIDEBAR_COLLAPSED_STORAGE_KEY = 'syncro.sidebar.collapsed';
const MOBILE_SIDEBAR_BREAKPOINT = 1024;

addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Limpiar'
});

const App = (props) => {
    const [rightMenuActive, setRightMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
    const [menuMode, setMenuMode] = useState('sidebar');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [ripple, setRipple] = useState(true);
    const [sidebarStatic, setSidebarStatic] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(
        () => localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true'
    );
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [isMobileViewport, setIsMobileViewport] = useState(() => window.innerWidth <= MOBILE_SIDEBAR_BREAKPOINT);
    const [menuActive, setMenuActive] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [sidebarActive, setSidebarActive] = useState(false);
    const [, setPinActive] = useState(false);
    const [activeInlineProfile, setActiveInlineProfile] = useState(false);
    const [resetActiveIndex, setResetActiveIndex] = useState(null);
    const [preferredLanguage, setPreferredLanguage] = useState(getPreferredLanguage());
    const [purchasingEnabled, setPurchasingEnabled] = useState(false);
    const [purchasingAlertCount, setPurchasingAlertCount] = useState(0);
    const copyTooltipRef = useRef();
    const location = useLocation();

    const isLoading = useSelector((state) => state?.utilitySlice?.isLoading);

    // Dev bypass: view app without backend login. Use ?bypass=1 in the URL (e.g. /repair-orders?bypass=1) or set REACT_APP_DEV_BYPASS_AUTH=true in .env
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const bypassFromUrl = urlParams.get('bypass') === '1';
        const bypassFromEnv = process.env.REACT_APP_DEV_BYPASS_AUTH === 'true';
        if (!bypassFromUrl && !bypassFromEnv) return;

        const existing = localStorage.getItem('userDetails');
        if (existing && !bypassFromUrl) return;

        const mockPayload = {
            message: 'Dev preview',
            data: {
                adminUser: {
                    _id: 'dev-user',
                    firstName: 'Dev',
                    lastName: 'User',
                    role: { uid: 'admin', _id: 'dev-role' }
                },
                token: 'dev-bypass-token',
                accessToken: 'dev-bypass-token'
            }
        };
        localStorage.setItem('userDetails', JSON.stringify(mockPayload));
        localStorage.setItem('adminUser', JSON.stringify(mockPayload));
        if (bypassFromUrl) {
            window.history.replaceState({}, '', window.location.pathname);
        }
        window.location.reload();
    }, []);

    PrimeReact.ripple = true;
    const user = JSON.parse(localStorage.getItem('userDetails'));
    const adminUser = user?.data?.adminUser || {};
    const role = adminUser?.role || {};
    const normalizedRoleUid = String(role?.uid || '').trim();
    const normalizedEmail = String(adminUser?.email || '').trim().toLowerCase();
    const normalizedRoleTitle = String(role?.title || role?.name || role || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
    const roleUid = normalizedRoleUid;
    const mustChangePassword = Boolean(adminUser?.mustChangePassword);
    useModuleAccessRefresh(adminUser?._id, user?.data?.token || user?.data?.accessToken, mustChangePassword);
    const supplyDispatchAccess = useSupplyDispatchAccess(adminUser?._id, user?.data?.token || user?.data?.accessToken, mustChangePassword);

    const isAdmin = roleUid === 'admin' || roleUid === 'superAdmin';
    useEffect(() => {
        let cancelled = false;
        setPurchasingEnabled(false);
        if (isAdmin) purchasingApi('status').then(data => { if (!cancelled) setPurchasingEnabled(Boolean(data.enabled)); }).catch(() => { if (!cancelled) setPurchasingEnabled(false); });
        return () => { cancelled = true; };
    }, [isAdmin, adminUser?._id]);
    useEffect(() => {
        let cancelled = false;
        const refresh = () => { if (isAdmin && purchasingEnabled) purchasingApi('alerts/count').then(data => { if (!cancelled) setPurchasingAlertCount(data.count || 0); }).catch(() => {}); };
        setPurchasingAlertCount(0); refresh();
        const timer = isAdmin && purchasingEnabled ? setInterval(refresh, 60000) : null;
        window.addEventListener('purchasing-alerts-changed', refresh);
        return () => { cancelled = true; if (timer) clearInterval(timer); window.removeEventListener('purchasing-alerts-changed', refresh); };
    }, [isAdmin, purchasingEnabled, adminUser?._id]);
    const isSupport = roleUid === 'support';
    const canAccessCallHistory = canReadCallHistory(roleUid, adminUser);
    const isTechnician = roleUid === 'technician';
    const isOperator = roleUid === 'operator';
    const canAccessMachinePlatforms = canUserAccessMachinePlatforms(adminUser);
    const isFinance = roleUid === 'finance';
    const isWarehouse = roleUid === 'warehouse';
    const isDemoRequester = DEMO_REQUESTER_EMAILS.has(normalizedEmail);
    const canReviewOperatorAnomalies = Boolean(adminUser?.canReviewOperatorAnomalies);
    const canAccessQuickBooksFinanceDashboard = isAdmin || isFinance || hasQuickBooksFinanceDashboardAccess(normalizedEmail);
    const canAccessQuickBooksManagementDashboard = isAdmin || hasQuickBooksManagementDashboardAccess(normalizedEmail);
    const canAccessQuickBooks = canAccessQuickBooksFinanceDashboard || canAccessQuickBooksManagementDashboard;
    const canAccessVentas = isAdmin || COMMERCIAL_ROLE_UIDS.has(roleUid) || adminUser?.salesCrmAccess === true || adminUser?.salesSupplierEditAccess === true;
    const canAccessOperatorDashboard =
        isAdmin ||
        isOperator ||
        canReviewOperatorAnomalies ||
        OPERATOR_DASHBOARD_FULL_ACCESS_EMAILS.has(normalizedEmail);
    const isHumanResources =
        roleUid === 'humanResources' ||
        normalizedRoleTitle === 'recursos humanos' ||
        normalizedRoleTitle === 'human resources' ||
        normalizedRoleTitle === 'hr';
    const normalizeTeamText = (value) => {
        if (typeof value !== 'string') return '';
        return value
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLowerCase();
    };
    const supportTeamCandidates = [
        adminUser?.team?.name,
        adminUser?.team?.title,
        adminUser?.teamName,
        adminUser?.teamTitle,
        adminUser?.team,
        adminUser?.teamLabel,
        adminUser?.teamId?.name,
        adminUser?.teamId?.title,
        ...(Array.isArray(adminUser?.teams) ? adminUser.teams.map((team) => team?.name || team?.title || team) : [])
    ];
    const normalizedTeamCandidates = supportTeamCandidates.map(normalizeTeamText).filter(Boolean);
    const hasExactTeam = (...teamNames) => {
        const normalizedTargets = teamNames.map(normalizeTeamText).filter(Boolean);
        return normalizedTargets.some((target) => normalizedTeamCandidates.includes(target));
    };
    const hasSupportTeamMetadata = normalizedTeamCandidates.length > 0;
    const isSupportTechnicianTeam = normalizedTeamCandidates.some((text) => {
        return (
            text.includes('technician') ||
            text.includes('tech') ||
            text.includes('tecnico') ||
            text.includes('tecnicos') ||
            text.includes('maintenance') ||
            text.includes('mantenimiento')
        );
    });
    const canAccessPreventiveMaintenance = true;
    const canAccessPartsInventory =
        isAdmin ||
        isTechnician ||
        (isSupport && (!hasSupportTeamMetadata || isSupportTechnicianTeam));
    const canAccessCustomerReports =
        isAdmin ||
        (isSupport && (hasExactTeam('Customer Support') || hasExactTeam('Operations') || hasExactTeam('Technician')));
    const canAccessModule = (moduleKey, legacyAllowed) =>
        canUserAccessModule(adminUser, moduleKey, legacyAllowed);
    const guardModule = (moduleKey, component, legacyAllowed) =>
        canAccessModule(moduleKey, legacyAllowed) ? component : <Access colorScheme={props.colorScheme} />;
    const appT = (value) => translateUiText(value, preferredLanguage);

    useEffect(() => {
        const syncPreferredLanguage = () => setPreferredLanguage(getPreferredLanguage());
        window.addEventListener('preferred-language-changed', syncPreferredLanguage);
        window.addEventListener('storage', syncPreferredLanguage);

        return () => {
            window.removeEventListener('preferred-language-changed', syncPreferredLanguage);
            window.removeEventListener('storage', syncPreferredLanguage);
        };
    }, []);

    useEffect(() => {
        setPrimeLocale(preferredLanguage === 'es' ? 'es' : 'en');
    }, [preferredLanguage]);

    const okrMenuItem = {
        label: <b>{appT('OKR')}</b>,
        icon: 'pi pi-flag',
        to: '/okr'
    };
    const ventasMenuItem = {
        label: <b>{appT('Sales')}</b>,
        icon: 'pi pi-briefcase',
        to: '/ventas'
    };
    const operatorDashboardMenuItem = {
        label: <b>{appT('Operator Dashboard')}</b>,
        icon: 'pi pi-chart-bar',
        to: '/operator-dashboard'
    };

    let navMenu = isAdmin
        ? [
              {
                  label: <b>{appT('Dashboard')}</b>,
                  icon: 'pi pi-fw pi-home',
                  to: '/'
              },
              {
                  label: <b>{appT('User Management')}</b>,
                  icon: 'pi pi-user',
                  to: '/user-list'
              },
              {
                  label: <b>{appT('Teams Management')}</b>,
                  icon: 'pi pi-sitemap',
                  to: '/team-list'
              },
              {
                  label: <b>{appT('Machine Management')}</b>,
                  icon: 'pi pi-server',
                  to: '/machine-list'
              },
              {
                  label: <b>{appT('Repair Orders')}</b>,
                  icon: 'pi pi-wrench',
                  to: '/repair-orders'
              },
              ventasMenuItem,
              {
                  label: <b>{appT('Machine Movements')}</b>,
                  icon: 'pi pi-external-link',
                  to: '/machine-movements'
              },
              {
                  label: <b>{appT('Preventive Maintenance')}</b>,
                  icon: 'pi pi-calendar',
                  to: '/preventive-maintenance'
              },
              {
                  label: <b>{appT('Parts Inventory')}</b>,
                  icon: 'pi pi-server',
                  to: '/parts-inventory'
              },
              {
                  label: <b>{appT('Question Management')}</b>,
                  icon: 'pi pi-question-circle',
                  to: '/managequestions'
              },
              {
                  label: <b>{appT('Complain Management')}</b>,
                  icon: 'pi pi-comments',
                  items: [
                      { label: <b>{appT('Open Complaints')}</b>, icon: 'pi pi-unlock', to: '/open-complaints' },
                      { label: <b>{appT('Refund Queue')}</b>, icon: 'pi pi-wallet', to: '/refund-queue' },
                      { label: <b>{appT('Close Complaints')}</b>, icon: 'pi pi-lock', to: '/close-complaints' }
                  ]
              },
              {
                  label: <b>{appT('Analytics & Reports')}</b>,
                  icon: 'pi pi-chart-bar',
                  to: '/reports'
              },
              {
                  label: <b>{appT('Customer Reports')}</b>,
                  icon: 'pi pi-chart-line',
                  to: '/customer-reports'
              },
              {
                  label: <b>{appT('Operations & People')}</b>,
                  icon: 'pi pi-briefcase',
                  to: '/hr-module'
              },
              okrMenuItem,
              operatorDashboardMenuItem,
              {
                  label: <b>{appT('Parlevel')}</b>,
                  icon: 'pi pi-cloud-download',
                  to: '/parlevel'
              },
              {
                  label: <b>{appT('Route Planning')}</b>,
                  icon: 'pi pi-map',
                  to: '/parlevel/routes'
              },
              {
                  label: <b>{appT('QuickBooks')}</b>,
                  icon: 'pi pi-chart-line',
                  to: '/quickbooks'
              }
          ]
        : isSupport
        ? [
              {
                  label: <b>{appT('Dashboard')}</b>,
                  icon: 'pi pi-fw pi-home',
                  to: '/'
              },
              {
                  label: <b>{appT('Machine Management')}</b>,
                  icon: 'pi pi-server',
                  to: '/machine-list'
              },
              {
                  label: <b>{appT('Repair Orders')}</b>,
                  icon: 'pi pi-wrench',
                  to: '/repair-orders'
              },
              {
                  label: <b>{appT('Machine Movements')}</b>,
                  icon: 'pi pi-external-link',
                  to: '/machine-movements'
              },
              ...(canAccessPartsInventory
                  ? [
                        {
                            label: <b>{appT('Parts Inventory')}</b>,
                            icon: 'pi pi-server',
                            to: '/parts-inventory'
                        }
                    ]
                  : []),
              ...(canAccessPreventiveMaintenance
                  ? [
                        {
                            label: <b>{appT('Preventive Maintenance')}</b>,
                            icon: 'pi pi-calendar',
                            to: '/preventive-maintenance'
                        }
                    ]
                  : []),
              {
                  label: <b>{appT('Complain Management')}</b>,
                  icon: 'pi pi-comments',
                  items: [
                      { label: <b>{appT('Open Complaints')}</b>, icon: 'pi pi-unlock', to: '/open-complaints' },
                      { label: <b>{appT('Close Complaints')}</b>, icon: 'pi pi-lock', to: '/close-complaints' }
                  ]
              },
              ...(canAccessCustomerReports
                  ? [
                        {
                            label: <b>{appT('Customer Reports')}</b>,
                            icon: 'pi pi-chart-line',
                            to: '/customer-reports'
                        }
                    ]
                  : []),
              {
                  label: <b>{appT('Parlevel')}</b>,
                  icon: 'pi pi-cloud-download',
                  to: '/parlevel'
              },
              {
                  label: <b>{appT('Route Planning')}</b>,
                  icon: 'pi pi-map',
                  to: '/parlevel/routes'
              },
              {
                  label: <b>{appT('Operations & People')}</b>,
                  icon: 'pi pi-briefcase',
                  to: '/hr-module'
              },
              ...(canAccessQuickBooks
                  ? [
                        {
                            label: <b>{appT('QuickBooks')}</b>,
                            icon: 'pi pi-chart-line',
                            to: '/quickbooks'
                        }
                    ]
                  : [])
          ]
        : isTechnician
        ? [
              {
                  label: <b>{appT('Machine Management')}</b>,
                  icon: 'pi pi-server',
                  to: '/machine-list'
              },
              {
                  label: <b>{appT('Repair Orders')}</b>,
                  icon: 'pi pi-wrench',
                  to: '/repair-orders'
              },
              {
                  label: <b>{appT('Machine Movements')}</b>,
                  icon: 'pi pi-external-link',
                  to: '/machine-movements'
              },
              {
                  label: <b>{appT('Preventive Maintenance')}</b>,
                  icon: 'pi pi-calendar',
                  to: '/preventive-maintenance'
              },
              ...(canAccessCustomerReports
                  ? [
                        {
                            label: <b>{appT('Customer Reports')}</b>,
                            icon: 'pi pi-chart-line',
                            to: '/customer-reports'
                        }
                    ]
                  : []),
              {
                  label: <b>{appT('Parts Inventory')}</b>,
                  icon: 'pi pi-server',
                  to: '/parts-inventory'
              },
              {
                  label: <b>{appT('Operations & People')}</b>,
                  icon: 'pi pi-briefcase',
                  to: '/hr-module'
              }
          ]
        : isOperator
        ? [
              operatorDashboardMenuItem,
              {
                  label: <b>{appT('Repair Orders')}</b>,
                  icon: 'pi pi-wrench',
                  to: '/repair-orders'
              },
              {
                  label: <b>{appT('Preventive Maintenance')}</b>,
                  icon: 'pi pi-calendar',
                  to: '/preventive-maintenance'
              },
              {
                  label: <b>{appT('Operations & People')}</b>,
                  icon: 'pi pi-briefcase',
                  to: '/hr-module'
              }
          ]
        : isFinance
        ? [
              {
                  label: <b>{appT('Refund Queue')}</b>,
                  icon: 'pi pi-wallet',
                  to: '/refund-queue'
              },
              {
                  label: <b>{appT('QuickBooks')}</b>,
                  icon: 'pi pi-chart-line',
                  to: '/quickbooks'
              }
          ]
        : isHumanResources
        ? [
              {
                  label: <b>{appT('Complain Management')}</b>,
                  icon: 'pi pi-comments',
                  items: [
                      { label: <b>{appT('Open Complaints')}</b>, icon: 'pi pi-unlock', to: '/open-complaints' }
                  ]
              },
              {
                  label: <b>{appT('Operations & People')}</b>,
                  icon: 'pi pi-briefcase',
                  to: '/hr-module'
              }
          ]
        : isWarehouse
        ? [okrMenuItem]
        : [
              {
                  label: <b>{appT('Dashboard')}</b>,
                  icon: 'pi pi-fw pi-home',
                  to: '/'
              },
              {
                  label: <b>{appT('Machine Management')}</b>,
                  icon: 'pi pi-server',
                  to: '/machine-list'
              },
              {
                  label: <b>{appT('Repair Orders')}</b>,
                  icon: 'pi pi-wrench',
                  to: '/repair-orders'
              },
              {
                  label: <b>{appT('Machine Movements')}</b>,
                  icon: 'pi pi-external-link',
                  to: '/machine-movements'
              },
              {
                  label: <b>{appT('Preventive Maintenance')}</b>,
                  icon: 'pi pi-calendar',
                  to: '/preventive-maintenance'
              },
              {
                  label: <b>{appT('Operations & People')}</b>,
                  icon: 'pi pi-briefcase',
                  to: '/hr-module'
              }
          ];

    if (!navMenu.some((item) => item.to === '/okr')) {
        navMenu = [...navMenu, okrMenuItem];
    }
    if (canAccessOperatorDashboard && !navMenu.some((item) => item.to === '/operator-dashboard')) {
        navMenu = [...navMenu, operatorDashboardMenuItem];
    }
    if (canAccessVentas && !navMenu.some((item) => item.to === '/ventas')) {
        navMenu = [...navMenu, ventasMenuItem];
    }

    const isDefaultNavigationRole = !isAdmin && !isSupport && !isTechnician && !isOperator && !isFinance && !isHumanResources && !isWarehouse;
    const navigationAccess = {
        canSeeCoffeeRegistration: canAccessCoffeeRegistration(adminUser),
        canSeeCoffeeStatistics: canAccessCoffeeStatistics(adminUser),
        canSeeCallHistory: canAccessCallHistory,
        isOperator,
        canAccessVentas: canAccessModule('ventas', canAccessVentas),
        canAccessOperatorDashboard: canAccessModule('operator_dashboard', canAccessOperatorDashboard) || canAccessCoffeeRegistration(adminUser),
        canAccessCustomerReports: canAccessModule('customer_reports', canAccessCustomerReports),
        canAccessParlevelOverview: canAccessMachinePlatforms && (canAccessModule('parlevel', isAdmin || isSupport)),
        canAccessParlevelRoutePlanning: canAccessMachinePlatforms && (Boolean(adminUser?._id)),
        canAccessParlevelChangeLevels: canAccessMachinePlatforms && (canAccessModule('parlevel_change_levels', isAdmin || isSupport)),
        canAccessParlevelData: canAccessMachinePlatforms && (canAccessModule('parlevel_data', isAdmin || isSupport)),
        canSeeQuickBooks: canAccessModule('quickbooks', canAccessQuickBooks),
        // Deliberately role-only: effective module overrides cannot grant accounting access.
        canSeeRevenueReconciliation: isAdmin,
        canSeePurchasing: isAdmin && purchasingEnabled,
        purchasingAlertCount,
        canAccessJetinno: canAccessMachinePlatforms && (isAdmin || (isSupport && hasExactTeam('Operations'))),
        canAccessProducts: isAdmin,
        canAccessTcn: canAccessMachinePlatforms && (true),
        canSeeDashboard: canAccessModule('dashboard', isAdmin || isSupport || isDefaultNavigationRole),
        canSeeMachines: canAccessModule('machine_list', isAdmin || isSupport || isTechnician || isDefaultNavigationRole),
        canSeeRoutes: canAccessModule('route_catalog', isAdmin || isSupport),
        canSeeMachineInspections: canAccessMachineInspections(adminUser),
        canSeeRepairOrders: canAccessModule('repair_orders', isAdmin || isSupport || isTechnician || isOperator || isDefaultNavigationRole),
        canSeeMachineMovements: canAccessModule('machine_movements', isAdmin || isSupport || isTechnician || isOperator || isDemoRequester || isDefaultNavigationRole),
        canSeePreventiveMaintenance: canAccessModule('preventive_maintenance', isAdmin || isSupport || isTechnician || isOperator || isDefaultNavigationRole),
        canSeePartsInventory: canAccessModule('parts_inventory', isAdmin || isTechnician || (isSupport && canAccessPartsInventory)),
        canSeeOpenComplaints: canAccessModule('open_complaints', isAdmin || isSupport || isHumanResources),
        canSeeRefundQueueInComplaints: !isFinance && canAccessModule('refund_queue', isAdmin),
        canSeeCloseComplaints: canAccessModule('close_complaints', isAdmin || isSupport),
        canSeeStandaloneRefundQueue: isFinance && canAccessModule('refund_queue', isFinance),
        canSeeOperationsAndPeople: canAccessModule('hr_module', true),
        canSeeSupplyDispatch: supplyDispatchAccess.actions.includes('ver'),
        canSeeUsers: canAccessModule('user_list', isAdmin),
        canSeeTeams: canAccessModule('team_list', isAdmin),
        canSeeReports: canAccessModule('reports', isAdmin || isSupport),
        canSeeQuestions: canAccessModule('manage_questions', isAdmin),
        canSeeOkr: canAccessModule('okr', true)
    };
    const navigationSections = buildSyncroNavigation(navigationAccess, appT);

    let rightMenuClick;
    let configClick;
    let menuClick;
    let searchClick = false;
    let topbarItemClick;

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(() => {
        setResetActiveIndex(true);
        setMenuActive(false);
    }, [menuMode]);

    useEffect(() => {
        const handleViewportChange = () => {
            const nextIsMobile = window.innerWidth <= MOBILE_SIDEBAR_BREAKPOINT;
            setIsMobileViewport(nextIsMobile);
            if (!nextIsMobile) {
                setStaticMenuMobileActive(false);
            }
        };

        window.addEventListener('resize', handleViewportChange);
        return () => window.removeEventListener('resize', handleViewportChange);
    }, []);

    useEffect(() => {
        setStaticMenuMobileActive(false);
    }, [location.pathname]);

    useEffect(() => {
        document.body.classList.toggle('syncro-mobile-navigation-open', isMobileViewport && staticMenuMobileActive);

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                setStaticMenuMobileActive(false);
            }
        };

        if (isMobileViewport && staticMenuMobileActive) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.body.classList.remove('syncro-mobile-navigation-open');
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isMobileViewport, staticMenuMobileActive]);

    const onDocumentClick = () => {
        if (!searchClick && searchActive) {
            onSearchHide();
        }

        if (!topbarItemClick) {
            setTopbarMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
                setResetActiveIndex(true);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                setOverlayMenuActive(false);
                setStaticMenuMobileActive(false);
            }

            hideOverlayMenu();
            unblockBodyScroll();
        }

        if (!rightMenuClick) {
            setRightMenuActive(false);
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        topbarItemClick = false;
        menuClick = false;
        configClick = false;
        rightMenuClick = false;
        searchClick = false;
    };

    const onSearchHide = () => {
        setSearchActive(false);
        searchClick = false;
    };

    const onMenuModeChange = (menuMode) => {
        setMenuMode(menuMode);
        setOverlayMenuActive(false);
    };

    const onRightMenuClick = () => {
        rightMenuClick = true;
    };

    const onRightMenuActiveChange = (active) => {
        setRightMenuActive(active);
    };

    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = (event) => {
        setConfigActive((prevState) => !prevState);
        configClick = true;
        event?.preventDefault?.();
    };

    const onRippleChange = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;

        if (isMobileViewport) {
            setStaticMenuMobileActive((prevState) => !prevState);
        } else {
            setStaticMenuDesktopInactive((prevState) => {
                const nextState = !prevState;
                localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(nextState));
                return nextState;
            });
        }

        event?.preventDefault?.();
    };

    const onToggleSidebar = (event) => {
        menuClick = true;
        setStaticMenuDesktopInactive((prevState) => {
            const nextState = !prevState;
            localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(nextState));
            return nextState;
        });
        event?.preventDefault?.();
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const onTopbarItemClick = (event) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevState) => !prevState);
        hideOverlayMenu();
        event?.preventDefault?.();
    };

    const onToggleMenu = (event) => {
        menuClick = true;

        if (overlayMenuActive) {
            setOverlayMenuActive(false);
        }

        if (sidebarActive) {
            setSidebarStatic((prevState) => !prevState);
        }

        event?.preventDefault?.();
    };

    const onSidebarMouseOver = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setSidebarActive(isDesktop());
            setTimeout(() => {
                setPinActive(isDesktop());
            }, 200);
        }
    };

    const onSidebarMouseLeave = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setTimeout(() => {
                setSidebarActive(false);
                setPinActive(false);
            }, 250);
        }
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onChangeActiveInlineMenu = (event) => {
        setActiveInlineProfile((prevState) => !prevState);
        event?.preventDefault?.();
    };

    const onRootMenuItemClick = () => {
        setMenuActive((prevState) => !prevState);
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();
            setResetActiveIndex(true);
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isDesktop = () => {
        return window.innerWidth > MOBILE_SIDEBAR_BREAKPOINT;
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const layoutClassName = classNames('layout-wrapper', 'syncro-layout', {
        'layout-static': menuMode === 'static',
        'layout-overlay': menuMode === 'overlay',
        'layout-overlay-active': overlayMenuActive,
        'layout-slim': menuMode === 'slim',
        'layout-horizontal': menuMode === 'horizontal',
        'layout-active': menuActive,
        'layout-mobile-active': staticMenuMobileActive,
        'layout-sidebar': menuMode === 'sidebar',
        'layout-sidebar-static': menuMode === 'sidebar' && sidebarStatic,
        'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
        'syncro-layout--collapsed': staticMenuDesktopInactive && !isMobileViewport,
        'syncro-layout--mobile-open': staticMenuMobileActive && isMobileViewport,
        'p-ripple-disabled': !ripple
    });

    return (
        <div className={layoutClassName} onClick={onDocumentClick}>
            <DevelopmentSafety admin={isAdmin} />
            <LoadingOverlay active={isLoading} spinner text="Please Wait ...">
                <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
                {!user ? (
                    <Routes>
                        <Route path="/forgetpassword" element={<ForgetPassword />} />
                        <Route path="*" element={<Login />} />
                    </Routes>
                ) : mustChangePassword ? (
                    <Routes>
                        <Route path="/force-password" element={<ForcePasswordChange />} />
                        <Route path="*" element={<Navigate to="/force-password" replace />} />
                    </Routes>
                ) : (
                    <div className="layout-main">
                        <AppTopbar
                            items={navMenu}
                            menuMode={menuMode}
                            colorScheme={props.colorScheme}
                            menuActive={menuActive}
                            topbarMenuActive={topbarMenuActive}
                            activeInlineProfile={activeInlineProfile}
                            onTopbarItemClick={onTopbarItemClick}
                            onMenuButtonClick={onMenuButtonClick}
                            onSidebarMouseOver={onSidebarMouseOver}
                            onSidebarMouseLeave={onSidebarMouseLeave}
                            onToggleMenu={onToggleMenu}
                            onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                            onMenuClick={onMenuClick}
                            onMenuItemClick={onMenuItemClick}
                            onRootMenuItemClick={onRootMenuItemClick}
                            resetActiveIndex={resetActiveIndex}
                            mobileMenuActive={staticMenuMobileActive && isMobileViewport}
                            translate={appT}
                        />

                        <SyncroSidebar
                            sections={navigationSections}
                            collapsed={staticMenuDesktopInactive && !isMobileViewport}
                            isMobileViewport={isMobileViewport}
                            mobileOpen={staticMenuMobileActive && isMobileViewport}
                            onInteraction={onMenuClick}
                            onToggleCollapsed={onToggleSidebar}
                            onCloseMobile={() => setStaticMenuMobileActive(false)}
                            translate={appT}
                        />

                        {/* <AppBreadcrumb
                            routes={routes}
                            onMenuButtonClick={onMenuButtonClick}
                            menuMode={menuMode}
                            onRightMenuButtonClick={onRightMenuButtonClick}
                            onInputClick={onInputClick}
                            searchActive={searchActive}
                            breadcrumbClick={breadcrumbClick}
                        /> */}

                        <div className="layout-main-content">
                            <WorkspaceTabs access={navigationAccess} translate={appT} />
                            <Routes>
                                <Route
                                    path="/"
                                    exact="true"
                                    element={
                                        canAccessModule('dashboard', !isHumanResources && !isTechnician && !isOperator)
                                            ? <Dashboard />
                                            : canAccessModule('operator_dashboard', isOperator)
                                            ? <Navigate to="/operator-dashboard" replace />
                                            : canAccessModule('repair_orders', isTechnician || isOperator)
                                            ? <Navigate to="/repair-orders" replace />
                                            : canAccessModule('hr_module', isHumanResources)
                                            ? <Navigate to="/hr-module" replace />
                                            : canAccessModule('okr', isWarehouse)
                                            ? <Navigate to="/okr" replace />
                                            : <Access colorScheme={props.colorScheme} />
                                    }
                                />
                                <Route path="/login" exact="false" element={<Login />} />
                                <Route path="/despacho-insumos/*" element={<SupplyDispatch access={supplyDispatchAccess} />} />
                                <Route path="/purchasing" element={isAdmin && purchasingEnabled ? <Purchasing /> : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/purchasing-draft" element={isAdmin && purchasingEnabled ? <PurchasingDraft /> : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/route-management" element={guardModule('route_catalog', <RouteManagement />, isAdmin || isSupport)} />
                                <Route path="/user-list" exact="false" element={guardModule('user_list', <Users />, !isHumanResources)} />
                                <Route
                                    path="/machine-list"
                                    exact="false"
                                    element={guardModule('machine_list', <Machines />, !isHumanResources && !isOperator)}
                                />
                                <Route path="/machine-inspections" element={canAccessMachineInspections(adminUser) ? <MachineInspections user={adminUser} /> : <Access />} />
                                <Route path="/registro-estadisticas" element={canAccessCoffeeRegistration(adminUser) ? <Navigate to="/operator-dashboard?tab=coffee" replace /> : <Access />} />
                                <Route path="/estadisticas-maquinas-cafe" element={canAccessCoffeeStatistics(adminUser) ? <CoffeeStatistics /> : <Access />} />
                                <Route path="/repair-orders" exact="false" element={guardModule('repair_orders', <RepairOrders />, !isHumanResources)} />
                                <Route path="/repair-orders/:id" exact="false" element={guardModule('repair_orders', <RepairOrderDetail />, !isHumanResources)} />
                                <Route
                                    path="/machine-movements"
                                    exact="false"
                                    element={guardModule('machine_movements', <MachineMovements />, !isHumanResources)}
                                />
                                <Route
                                    path="/preventive-maintenance"
                                    exact="false"
                                    element={guardModule('preventive_maintenance', <PreventiveMaintenance />, !isHumanResources && canAccessPreventiveMaintenance)}
                                />
                                <Route
                                    path="/parts-inventory"
                                    exact="false"
                                    element={guardModule('parts_inventory', <PartsInventory />, !isHumanResources && canAccessPartsInventory)}
                                />
                                <Route path="/managequestions" exact="false" element={guardModule('manage_questions', <Questions />, !isHumanResources)} />
                                <Route path="/team-list" exact="false" element={guardModule('team_list', <Teams />, !isHumanResources)} />
                                <Route path="/call-history" element={canAccessCallHistory ? <CallHistory /> : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/open-complaints" exact="false" element={guardModule('open_complaints', <OpenComplaints />, true)} />
                                <Route path="/refund-queue" exact="false" element={guardModule('refund_queue', <RefundQueue />, !isHumanResources && (isAdmin || isFinance))} />
                                <Route path="/close-complaints" exact="false" element={guardModule('close_complaints', <CloseComplaints />, !isHumanResources)} />
                                <Route path="/complaints/chat" exact="false" element={<ChatBox />} />
                                <Route path="/profile" exact="false" element={<Profile />} />
                                <Route path="/reports" exact="false" element={guardModule('reports', <Reports />, !isHumanResources)} />
                                <Route
                                    path="/customer-reports"
                                    exact="false"
                                    element={guardModule('customer_reports', <CustomerMachineReport />, !isHumanResources && canAccessCustomerReports)}
                                />
                                <Route path="/hr-module" exact="false" element={guardModule('hr_module', <HRModule />, true)} />
                                <Route path="/okr" element={guardModule('okr', <OKRModule />, true)} />
                                <Route path="/ventas" element={guardModule('ventas', <VentasModule />, canAccessVentas)} />
                                <Route path="/operator-dashboard" element={canAccessModule('operator_dashboard', canAccessOperatorDashboard) || canAccessCoffeeRegistration(adminUser) ? <OperatorDashboard user={adminUser} dashboardAccess={canAccessModule('operator_dashboard', canAccessOperatorDashboard)} /> : <Access />} />
                                <Route path="/parlevel" element={canAccessMachinePlatforms ? guardModule('parlevel', <ParlevelDashboard />, !isHumanResources && (isAdmin || isSupport)) : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/parlevel/routes" element={canAccessMachinePlatforms && Boolean(adminUser?._id) ? <ParlevelRoutePlanning /> : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/parlevel/change-levels" element={canAccessMachinePlatforms ? guardModule('parlevel_change_levels', <ParlevelCoinTubes />, !isHumanResources && (isAdmin || isSupport)) : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/parlevel/data" element={canAccessMachinePlatforms ? guardModule('parlevel_data', <ParlevelData />, !isHumanResources && (isAdmin || isSupport)) : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/quickbooks" element={guardModule('quickbooks', <QuickBooksModule />, !isHumanResources && canAccessQuickBooks)} />
                                <Route path="/revenue-reconciliation" element={isAdmin ? <RevenueReconciliation /> : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/jetinno" element={canAccessMachinePlatforms && (isAdmin || (isSupport && hasExactTeam('Operations'))) ? <JetinnoDashboard /> : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/products" element={<Products isAdmin={isAdmin} />} />
                                <Route path="/tcn" element={canAccessMachinePlatforms ? <TcnDashboard isAdmin={isAdmin} /> : <Access colorScheme={props.colorScheme} />} />
                                <Route path="/jetinno/consumption" element={canAccessMachinePlatforms && (isAdmin || (isSupport && hasExactTeam('Operations'))) ? <JetinnoConsumptionReport /> : <Access colorScheme={props.colorScheme} />} />
                            </Routes>
                        </div>

                        <AppFooter colorScheme={props.colorScheme} />
                    </div>
                )}

                <AppRightMenu rightMenuActive={rightMenuActive} onRightMenuClick={onRightMenuClick} onRightMenuActiveChange={onRightMenuActiveChange} />

                <AppConfig
                    configActive={configActive}
                    onConfigButtonClick={onConfigButtonClick}
                    onConfigClick={onConfigClick}
                    menuMode={menuMode}
                    changeMenuMode={onMenuModeChange}
                    colorScheme={props.colorScheme}
                    changeColorScheme={props.onColorSchemeChange}
                    theme={props.theme}
                    changeTheme={props.onMenuThemeChange}
                    componentTheme={props.componentTheme}
                    changeComponentTheme={props.onComponentThemeChange}
                    ripple={ripple}
                    onRippleChange={onRippleChange}
                />
                <ToastContainer />
            </LoadingOverlay>
        </div>
    );
};

export default App;
